export const MAP_API_KEY = 'AIzaSyBk1Y3RjIlfRt5IyiK_SXuRwuGSQHgSsus';

// export const IMAGE_URL = 'http://localhost:8000/';
export const IMAGE_URL = 'https://api.magicmedia.ir/';
// export const IMAGE_URL = 'http://6452c72b.ngrok.io/';
export const API_URL = IMAGE_URL + 'api/v1/';
//alibaba
export const ALIBABA_USER = 'behnam.es.90@gmail.com';
export const ALIBABA_PASS = 'Ir@nRoute';
export const ALIBABA_URL = 'https://api.altrabo.com/api/v1/';

//table option
export const options = {
    rowsPerPage: 50,
    rowsPerPageOptions: [50, 100, 200, 500],
    download: false,
    print: false,
    filterType: 'checkbox',
    viewColumns: false,
    filter: false,
    selectableRows: false,
    textLabels: {
        body: {
            noMatch: "we are trying to catch your data ...",
        }
    }
};


// WEBPACK FOOTER //
// ./src/config/Config.js